import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectsFacade, decrypt, extractChildItems } from '@piqet-angular/data';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { cloneDeep } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'piqet-angular-grid-cell-renderer',
  templateUrl: './grid-cell-renderer.component.html',
  styleUrls: ['./grid-cell-renderer.component.css'],
})
export class GridCellRendererComponent implements AfterViewInit {
  params: any;
  processId: any;
  processList: any = [];
  bindLabel = '';
  bindValue = 'id';
  placeHolder = 'Process *';
  from: any;
  materialInfoData: any = [];
  materialInfoDataKey: any = [];
  materialInfoDataValues: any = [];
  materialname: any;
  packageScenarioId: any;
  activatedRoute: any;
  selectedId: any;
  isEOL: boolean = false;
  customWidth: any;
  customPaddingBottom: any;
  scenarioId: any;
  focusIndName: boolean = false;
  dropdownPosition: 'bottom' | 'top' = 'bottom';
  focusIndUnit: boolean = false;
  focusIndCountry: boolean = false;
  @ViewChildren('select') dropdowns!: QueryList<ElementRef>;
  public processList$!: BehaviorSubject<any[]>;
  constructor(
    private route: ActivatedRoute,
    private admin: AdministratorService,
    private projectService: ProjectsService,
    private taoster: ToastrService,
    private cdr: ChangeDetectorRef,
    private projectFacade: ProjectsFacade
  ) {}

  ngAfterViewInit(): void {
    const ngSelect = document.getElementsByClassName('crossIconSize');
    if (ngSelect) {
      ngSelect[0]?.classList.add('focused');
    }
  }

  refresh() {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    this.from = params.from;
    if (this.from == 'organizationMaterialName' || this.from == 'organizationConversionName') {
      const pageSize = params.api?.paginationGetPageSize();
      const rowIndex = params.node.rowIndex;
      if (rowIndex >= pageSize - 3) {
        this.dropdownPosition = 'top';
      } else {
        this.dropdownPosition = 'bottom';
      }
    }
    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.packageScenarioId = value['packageScenarioId'];
      this.scenarioId = value['scenarioId'];
    });

    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    switch (this.from) {
      case 'myProject':
        this.processId = params.data.materialId;
        this.processList = params?.defalutMaterialProjectList;
        this.bindLabel = 'description';
        break;
      case 'filling':
        this.processId = params.data.energyTypeId;
        this.processList = params?.fillingProcessList;
        this.bindLabel = 'name';
        this.customWidth = 280;
        break;
      case 'conversionProcess':
        this.processId = params.data.energyId;
        this.processList = params?.conversionProcessList;
        this.bindLabel = 'description';
        this.customWidth = 290;
        this.customPaddingBottom = 2;
        break;
      case 'storage':
        this.processId = params.data.energyProcessId;
        this.processList = params?.storageProcessList;
        this.bindLabel = 'name';
        this.customWidth = 450;
        break;
      case 'reuse':
        this.processId = params.data.energyProcessId;
        this.processList = params?.reuseIngredientList;
        this.bindLabel = 'name';
        this.customWidth = 450;
        break;
      case 'technology':
        this.processId = params.data.technology;
        this.processList = params?.technologyList;
        this.bindLabel = 'name';
        this.placeHolder = 'Select a technology';
        this.customWidth = 450;
        break;
      case 'materialIngridiant':
        this.processId = params.data.materialTypeId;
        this.processList = params?.materialIngredientList;
        this.getmaterialInfoDataTootlip(params.data.materialTypeId);
        this.bindLabel = 'description';
        this.placeHolder = 'Material *';
        this.customWidth = 240;
        this.customPaddingBottom = 0;
        break;
      case 'materialEolIdentifier':
        this.processId = params.data.endofLifeIdentifierId;
        this.processList = params?.endofLifeIdentifierName;
        this.bindLabel = 'name';
        this.placeHolder = 'EOL identifier';
        this.customPaddingBottom = 0;
        break;
      case 'materialProcess':
        this.processId = params.data.energyId;
        this.processList = params?.materialProcessList;
        this.bindLabel = 'description';
        this.customWidth = 290;
        this.customPaddingBottom = 0;
        this.placeHolder = 'Process name';
        break;
      case 'reuseProcessName':
        this.processId = params.data?.isCustomReuse
          ? params.data.customReuseId
          : params.data.energyProcessId;
        this.processList = params.data?.isCustomReuse
          ? params?.customReuseProcessList
          : params?.reuseProcessList;
        this.bindLabel = params.data?.isCustomReuse ? 'description' : 'name';
        this.customWidth = 290;
        this.bindValue = params.data?.isCustomReuse ? 'idStr' : 'id';
        this.customPaddingBottom = 0;
        this.placeHolder = 'Process name';
        break;
      case 'unitItems':
        this.processId = params.data.unitId;
        this.processList = params?.unitItems;
        this.bindLabel = 'name';
        this.placeHolder = 'Select a unit';
        this.customWidth = 290;
        this.customPaddingBottom = 0;
        break;
      case 'statusColDef':
      case 'verificationStatus':
      case 'organizationStatus': {
        const processId =
          params.colDef.field === 'verificationStatus'
            ? params.data.docStatus
            : params.data.statusId;

        this.setCommonStatusProperties(params, processId);
        break;
      }
      case 'orgReportingProcess':
        this.processId = params.data.id;
        this.processList = params?.newDefalutOrgReportingList.map((x: any) => {
          return { ...x, name: x.description };
        });
        this.bindLabel = 'name';
        this.placeHolder = 'Product group*';
        break;
      case 'orgReportingYear':
        this.processId = params.data.id;
        this.processList = params?.newDefalutOrgReportingList.map((x: any) => {
          return { ...x, name: x.description };
        });
        this.bindLabel = 'name';
        this.placeHolder = 'Year';
        break;
      case 'addSKU':
        this.processId = isNaN(params.data.year) ? 0 : Number(params.data.year);
        this.processList = params?.yearList.map((x: any) => {
          return { ...x, name: x.description };
        });
        this.customWidth = 450;
        this.bindLabel = 'name';
        this.placeHolder = 'Year ending in June';
        break;
      case 'addSKUProductGroup':
        this.processId = isNaN(params.data.productGroupId) ? 0 : Number(params.data.productGroupId);
        this.processList = params?.productGroupList?.map((x: any) => {
          return { ...x, name: x.name };
        });
        this.customWidth = 450;
        this.bindLabel = 'name';
        this.placeHolder = 'Product group';
        break;
      case 'packagingEOL':
        this.bindLabel = 'name';
        this.placeHolder = 'Material';
        this.isEOL = true;
        break;
      case 'ingredientName':
        this.processId = params.data.ingredientItemId;
        this.processList = params?.ingredientList;
        this.bindLabel = 'name';
        this.placeHolder = 'Ingredient';
        this.customWidth = 180;
        this.customPaddingBottom = 0;
        this.focusIndName = true;
        break;
      case 'organizationMaterialName':
        const allMaterial: any = extractChildItems(params?.context?.materialList);
        const material = allMaterial.find((x: any) => x.description == params.data.materialName);
        this.processId = material?.id || 0;
        this.processList = params?.context?.materialList;
        this.bindLabel = 'description';
        this.placeHolder = 'Organization material';
        this.customWidth = 180;
        this.customPaddingBottom = 0;
        this.focusIndName = true;
        break;
      case 'organizationConversionName':
        const allConversion = extractChildItems(params?.context?.conversionList);
        const conversion = allConversion.find((x: any) => x.name == params.data?.conversionName);
        this.processId = conversion?.id || 0;
        this.processList = params?.context?.conversionList;
        this.bindLabel = 'name';
        this.placeHolder = 'Organization conversion';
        this.customWidth = 180;
        this.customPaddingBottom = 0;
        this.focusIndName = true;
        break;
      case 'supplierName':
        this.processId = params.data.ingredientSupplierId;
        this.processList$ = params.supplierList$;
        this.bindLabel = 'name';
        this.placeHolder = 'Select supplier';
        this.customWidth = 180;
        this.customPaddingBottom = 0;
        break;
      case 'unitName':
        this.processId = params.data.unitName == 'g' ? 1 : 2;
        this.processList = params?.unitList;
        this.bindLabel = 'name';
        this.placeHolder = 'Unit';
        this.customWidth = 180;
        this.customPaddingBottom = 0;
        this.focusIndUnit = false;
        break;
      case 'ingredientCountry':
        this.processId = params.data.countryId;
        this.processList = params?.countryList;
        this.bindLabel = 'name';
        this.placeHolder = 'Country';
        this.customWidth = 180;
        this.customPaddingBottom = 0;
        this.focusIndCountry = false;
        break;
      default:
        break;
    }
  }
  setCommonStatusProperties(params: any, processId: any): void {
    this.processId = processId;
    this.processList = params?.statusList;
    this.bindLabel = 'name';
    this.placeHolder = 'Select a status';
    this.customWidth = 290;
    this.customPaddingBottom = 0;
  }

  toTitleCase(str: any) {
    return str.replace(/\w\S*/g, (txt: any) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  resetTValue(from: any) {
    if (from == 'technology') {
      this.params.data = { ...this.params.data };
      this.params.data.technologyName = 'null';
      this.params.data['technologyId'] = 0;
      this.params.data['isCheckUpdateDropDown'] = true;
      this.params.editData(this.params.data);
    } else if (from == 'materialEolIdentifier') {
      this.params.data = { ...this.params.data };
      this.params.data.endofLifeIdentifierId = null;
      this.params.data.endofLifeIdentifierName = '';
      this.params.editData(this.params.data);
    }
  }

  updateValue(event: any) {
    if (!!event?.id || !!Number(event?.idStr)) {
      this.params.data = cloneDeep(this.params.data);
      switch (this.from) {
        case 'filling':
          this.params.data.energyTypeId = event.id;
          this.params.data.processName = event.name;
          break;
        case 'myProject':
          this.params.data.materialId = event.id;
          break;
        case 'conversion':
          this.params.data.energyId = event.id;
          break;
        case 'conversionProcess':
          this.params.data.energyId = event.id;
          this.params.data.processName = event.description;
          break;
        case 'storage':
          this.params.data.energyName = event.name;
          this.params.data.energyProcessId = event.id;
          break;
        case 'reuse':
          this.params.data.energyProcessId = event.id;
          this.params.data.processName = event.name;
          break;
        case 'materialEolIdentifier':
          this.params.data.endofLifeIdentifierId = event.id;
          this.params.data.endofLifeIdentifierName = event.name;
          break;
        case 'materialIngridiant':
          this.params.data.materialTypeId = event.id;
          this.params.data.materialName = event.description;
          this.getmaterialInfoDataTootlip(event.id);
          break;
        case 'ingredientName':
          this.params.data.ingredientItemId = event.id;
          this.params.data.ingredientName = event.name;
          break;
        case 'supplierName':
          this.params.data.ingredientSupplierId = event.id;
          this.params.data.supplierName = event.name;
          break;
        case 'organizationMaterialName':
          this.params.data.materialId = event.id;
          this.params.data.materialName = event.description;
          break;
        case 'organizationConversionName':
          this.params.data.conversionId = event.id;
          this.params.data.conversionName = event.name;
          break;
        case 'unitName':
          this.params.data.unitName = event.name;
          break;
        case 'ingredientCountry':
          this.params.data.countryId = event.id;
          this.params.data.countryName = event.name;
          break;
        case 'materialProcess':
          this.params.data.energyId = event.id;
          this.params.data.processName = event.description;
          break;
        case 'orgReportingProcess':
          if (event.id) {
            this.params.data.id = event.id;
            this.params.data.productGroupName = event.description;
            this.params.data.packageScenarioId = this.packageScenarioId;
            this.updateOrgReporting(event, 'prodGrp');
          }
          break;
        case 'orgReportingYear':
          this.params.data.id = event;
          this.params.data.productGroupName = event.description;
          this.params.data.packageScenarioId = this.packageScenarioId;
          this.updateOrgReporting(event, 'year');
          break;
        case 'addSKU':
          this.params.data.id = event;
          this.params.data.year = event.name;
          break;

        case 'addSKUProductGroup':
          this.params.data.productGroupId = event.id;
          this.params.data.productGroupName = event.name;
          break;
        case 'technology':
          this.params.data.technologyName = event?.name;
          this.params.data['technologyId'] = event?.id;
          this.params.data['isCheckUpdateDropDown'] = true;
          break;
        case 'unitItems':
          this.params.data.name = event?.name;
          this.params.data['unitId'] = event?.id;
          break;
        case 'reuseProcessName':
          this.params.data.name = this.params.data?.isCustomReuse
            ? event?.description
            : event?.name;
          this.params.data['id'] = this.params.data?.isCustomReuse ? event?.idStr : event?.id;
          break;
        case 'statusColDef':
          this.params.data.name = event?.name;
          this.params.data['statusId'] = event?.id;
          break;
        case 'verificationStatus':
          this.params.data.name = event?.name;
          this.params.data.statusString = event?.name;
          this.params.data['docStatus'] = event?.id;
          break;
        case 'organizationStatus':
          this.params.data.name = event?.name;
          this.params.data.statusString = event?.name;
          this.params.data['statusId'] = event?.id;
          break;
        default:
          break;
      }
      this.params.editData(this.params.data);
    }
  }

  onClear(event: any) {
    let rowData = { ...this.params.data };
    switch (this.from) {
      case 'addSKU':
        const tempData = rowData;
        tempData.year = 'Select a year';
        this.params.editData(tempData);
        break;
      case 'addSKUProductGroup':
        const prodctGroup = rowData;
        prodctGroup.productGroupName = 'Select a product group';
        prodctGroup.productGroupId = null;
        this.params.editData(prodctGroup);
        break;
      case 'ingredientCountry':
        const ingredientCopy = rowData;
        ingredientCopy.countryId = null;
        ingredientCopy.countryName = '';
        this.params.editData(ingredientCopy);
        break;
      case 'unitItems':
        const unitData = rowData;
        unitData.name = '';
        unitData.unitName = '';
        unitData.unit = '';
        unitData.unitId = null;
        this.params.editData(unitData);
        break;
      case 'supplierName':
        const supplierData = rowData;
        supplierData.supplierName = '';
        supplierData.ingredientSupplierId = null;
        this.params.editData(supplierData);
        break;
      default:
        break;
    }
  }

  getValue(): any {
    return this.params.data;
  }

  getmaterialInfoDataTootlip(Id: any) {
    this.admin.GetMaterialInfo(Id, 0).subscribe((data: any) => {
      this.materialInfoData = data.data;
      this.materialname = this.materialInfoData.name;
      this.materialInfoDataKey = Object.keys(this.materialInfoData);
      this.materialInfoDataValues = Object.values(this.materialInfoData);
    });
  }

  async updateOrgReporting(data: any, type?: any) {
    const payload = {
      id: this.params.node?.data?.id || 0,
      numberofUnitsByYear: this.params.node?.data?.numberofUnitsByYear || 0,
      scnearioId: Number(this.packageScenarioId) || this.params.node?.data?.scnearioId,
      year: Number(this.params.node?.data?.configurationYear) || (type == 'year' ? data.id : 0),
      productGroupId: data.id,
      isCurrentPack: this.params.node?.data?.isCurrentPack || false,
    };
    let response;
    if (type != 'year') {
      response = await this.projectService.updateConfigYearForScenario(payload);
      response.data.index = this.params.data.index;
      response.data.packageScenarioId = this.packageScenarioId;
      this.taoster.success(response.message);
      this.projectFacade.updateOrgYearActions(response, 'edit', null, null, 'productgroup');
    }
  }

  focusOn(type: string) {
    const ids = [
      'currentDropdown1',
      'inline-ng-select',
      'currentDropdown2',
      'currentDropdown3',
      'ingredientCountryDrp',
      'unitNameDrp',
      'supplierNameDrp',
      'commonNumericEditor',
      'organizationMaterialName',
      'organizationConversionName',
    ];
    // Iterate through each id and toggle 'focused' class based on type
    ids.forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        if (type === id) {
          element.classList.add('focused');
        } else {
          if (id == 'commonNumericEditor') {
            element.classList.add('blurred');
          }
          element.classList.remove('focused');
        }
      }
    });
  }
}
